import {useAccountDm, useGroupListDm, usePortfolioDm, usePropertyDm} from "../../__snowpack__/link/packages/dm/dist/dm.esm.js";
import {useEffect, useState} from "react";
export function useParseFilters(listFilters, jwt, filters) {
  const {
    getAccountsAsFilter
  } = useAccountDm(jwt);
  const {
    getPortfoliosAsFilter
  } = usePortfolioDm(jwt);
  const {
    getPropertiesAsFilter
  } = usePropertyDm(jwt);
  const {
    getGroupsAsFilter
  } = useGroupListDm(jwt);
  const [allFilters, setAllFilters] = useState({});
  useEffect(() => {
    if (filters?.account) {
      getAccountsAsFilter({
        id: Array.isArray(filters.account) ? filters.account.join(",") : filters.account
      }).then((response) => {
        const accountFilters = response.results.map((res) => ({
          id: res.id,
          label: res.name
        }));
        setAllFilters((prevState) => ({
          ...prevState,
          account: accountFilters
        }));
      });
    }
  }, [filters?.account, getAccountsAsFilter]);
  useEffect(() => {
    if (filters?.group) {
      getGroupsAsFilter({
        id: Array.isArray(filters.group) ? filters.group.join(",") : filters.group
      }).then((response) => {
        const groupFilters = response.results.map((res) => ({
          id: res.id,
          label: res.name
        }));
        setAllFilters((prevState) => ({
          ...prevState,
          group: groupFilters
        }));
      });
    }
  }, [filters?.group, getGroupsAsFilter]);
  useEffect(() => {
    if (filters?.portfolio) {
      getPortfoliosAsFilter({
        id: Array.isArray(filters.portfolio) ? filters.portfolio.join(",") : filters.portfolio
      }).then((response) => {
        const portfolioFilters = response.results.map((res) => ({
          id: res.id,
          label: res.name
        }));
        setAllFilters((prevState) => ({
          ...prevState,
          portfolio: portfolioFilters
        }));
      });
    }
  }, [filters?.portfolio, getPortfoliosAsFilter]);
  useEffect(() => {
    if (filters?.property) {
      getPropertiesAsFilter({
        id: Array.isArray(filters.property) ? filters.property.join(",") : filters.property
      }).then((response) => {
        const propertyFilters = response.results.map((res) => ({
          id: res.id,
          label: res.name
        }));
        setAllFilters((prevState) => ({
          ...prevState,
          property: propertyFilters
        }));
      });
    }
  }, [filters?.property, getPropertiesAsFilter]);
  return {
    routeFilters: allFilters
  };
}
